exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"menuText": "#606266",
	"menuActiveText": "#fa8c16",
	"subMenuActiveText": "#fa8c16",
	"menuBg": "#fff",
	"menuHover": "#fff7e6",
	"subMenuBg": "#fafafa",
	"subMenuHover": "#fff7e6",
	"sideBarWidth": "220px",
	"primaryColor": "#fa8c16",
	"bgColor": "#fdfbf7"
};